import React from "react";
import { Element } from "react-scroll";
import { helpMatchHomePageWork } from "../../data/data";

const HelpMatchHomePageWork = ({ title }) => {
  return (
    <Element name="how-helpMatch">
      <section className="work px-5 pb-[50px] md:pb-[100px]">
        <div className="container bg-[#F1F4F6] px-5 md:px-[50px] py-[50px] md:pt-[75px] md:pb-[112px] rounded-tl-[30px] rounded-br-[30px] rounded-tr-[60px] rounded-bl-[60px] md:rounded-tl-[70px] md:rounded-br-[70px] md:rounded-tr-[160px] md:rounded-bl-[160px] relative">
          <h2 className="mb-[40px] md:mb-[68px] text-center text-[22px] md:text-[40px]">
          Finding Your Match is <span className="text-primary">3 Easy Steps</span> Away!
          </h2>
          {/* <div className="w-[14px] h-[14px] rounded-[50%] bg-dotColor1 absolute left-[57px] sm:left-[103px] md:left-[183px] md:top-[63px] top-[116px] animate-ping delay-400"></div>
          <div className="w-[14px] h-[14px] rounded-[50%] bg-dotColor2 absolute right-[66px] sm:right-[117px] top-[295px] sm:top-[322px] md:top-[117px] animate-ping delay-400"></div>
          <div className="w-[19px] h-[19px] rounded-[50%] bg-dotColor2 absolute left-[50px] sm:left-[80px] bottom-[30px] sm:bottom-[90px] animate-ping delay-400"></div>
          <div className="w-[9px] h-[9px] rounded-[50%] bg-dotColor3 absolute md:left-[60%] md:bottom-[20%] sm:left-[80%] left-[84%] top-[76%] sm:top-[80%] transform -translate-x-1/2 -translate-y-1/2 animate-ping delay-400"></div> */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-[30px] md:gap-[60px] text-center md:text-left">
            {helpMatchHomePageWork.map((work, index) => (
              <div key={`${index}-work`} className="flex items-center md:items-start gap-5 flex-col justify-center md:justify-normal md:flex-row">
                <div className="rounded-[13px] w-[60px] h-[60px] md:text-[30px] text-[24px] font-black leading-[180%] text-white flex items-center justify-center bg-[#768B9F]">
                  {index + 1}
                </div>
                <div className="md:max-w-[calc(100%-80px)] max-w-[280px] w-full">
                    <h5 className="text-lg font-bold leading-[160%] text-customGray mb-2 text-center md:text-left">{work.title}</h5>
                  <p className="font-medium leading-[160%] text-customGray text-base text-center md:text-left">
                    {work.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default HelpMatchHomePageWork;
